import type { TestListItemDto } from '@flowqa/shared';

const trimToNull = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : null;
};

const splitHierarchy = (value: string): string[] =>
  value
    .split('›')
    .map((part) => part.trim())
    .filter((part) => part.length > 0);

export const resolveTestEntityDisplayName = (
  test: Pick<TestListItemDto, 'name' | 'displayName' | 'suites'>,
  options?: { preferFileNameOverDisplayName?: boolean },
): string => {
  const displayName = trimToNull(test.displayName);
  const canonicalName = trimToNull(test.name);
  if (!canonicalName) return displayName ?? 'Unknown test';
  if (options?.preferFileNameOverDisplayName) return canonicalName;

  const hierarchy = splitHierarchy(canonicalName);
  if (hierarchy.length <= 1) return displayName ?? canonicalName;

  const primarySuite = test.suites?.primary ?? test.suites?.items?.[0] ?? null;
  const suiteLabel = trimToNull(primarySuite?.displayName) ?? trimToNull(primarySuite?.name);
  const leafLabel = displayName ?? hierarchy[hierarchy.length - 1];

  if (suiteLabel && hierarchy[0] === suiteLabel) {
    return hierarchy.slice(1).join(' › ');
  }

  const lastHierarchyLabel = hierarchy[hierarchy.length - 1] ?? null;
  if (displayName && lastHierarchyLabel === displayName) {
    return hierarchy.slice(1).join(' › ');
  }

  return leafLabel;
};
